import {Component, input} from '@angular/core';

@Component({
  selector: 'lib-tile-header',
  standalone: true,
  templateUrl: './tile-header.component.html',
  styleUrl: './tile-header.component.scss',
})
export class TileHeaderComponent {
  readonly title = input.required<string>();
}
